import { render } from "./AddonForm.vue?vue&type=template&id=5c5447fd&scoped=true"
import script from "./AddonForm.vue?vue&type=script&lang=js"
export * from "./AddonForm.vue?vue&type=script&lang=js"

import "./AddonForm.vue?vue&type=style&index=0&id=5c5447fd&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5447fd"]])

export default __exports__